import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponentBase } from '../../../../../shared/base-classes/menu-component-base';
import { takeUntil } from 'rxjs';
import { DeeprootsLinksComponent } from '../deeproots-links/deeproots-links.component';
import { DeeprootsFeedbackComponent } from '../deeproots-feedback/deeproots-feedback.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-deeproots-logs',
  standalone: true,
  imports: [CommonModule, DeeprootsLinksComponent, DeeprootsFeedbackComponent],
  templateUrl: './deeproots-logs.component.html',
  styleUrl: './deeproots-logs.component.scss',
})
export class DeeprootsLogsComponent
  extends MenuComponentBase
  implements OnInit
{
  router = inject(Router);
  activeTab: 'links' | 'feedback' = 'links';

  tabs = [
    { id: 'links' as const, label: 'Link Submissions' },
    { id: 'feedback' as const, label: 'Feedbacks' },
  ];

  override ngOnInit(): void {
    super.ngOnInit();
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        const tab = params['tab'];
        if (tab === 'links' || tab === 'feedback') {
          this.activeTab = tab;
        }
      });
  }

  onTabChange(tabId: 'links' | 'feedback'): void {
    this.activeTab = tabId;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queryParams: any = { tab: tabId };
    if (tabId === 'links') {
      queryParams.sort = null; // Remove sort param when switching to links
    }

    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }
}
